'use client';

import { c as _c } from "react/compiler-runtime";
import React, { useState } from 'react';
import Modal from '@/src/app/components/Modal/Modal.tsx';
import { Dictionary } from '@/src/lib/dictionary/types.ts';
import Icon from '@/src/app/components/Icon/Icon.tsx';
import { IconName } from '@/src/app/components/Icon/types.ts';
type PriceInfoProps = {
  dict: Dictionary;
  queryYourPrice: boolean;
  onModalOpen: () => void;
  priceInfoModalContent: React.JSX.Element;
  lang: string;
  country: string;
};
function PriceInfo(t0) {
  const $ = _c(17);
  const {
    dict,
    priceInfoModalContent,
    onModalOpen,
    queryYourPrice,
    lang,
    country
  } = t0;
  const [isModalOpen, setIsModalOpen] = useState(false);
  let t1;
  if ($[0] !== onModalOpen || $[1] !== queryYourPrice) {
    t1 = function onButtonClick() {
      setIsModalOpen(true);
      if (queryYourPrice) {
        onModalOpen();
      }
    };
    $[0] = onModalOpen;
    $[1] = queryYourPrice;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const onButtonClick = t1;
  let t2;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Icon name={IconName.INFO} className="text-black-900 text-lg! h-4 mr-1" />;
    t3 = <span className="sr-only">Price Info</span>;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  let t4;
  if ($[5] !== onButtonClick) {
    t4 = <button onClick={onButtonClick}>{t2}{t3}</button>;
    $[5] = onButtonClick;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => setIsModalOpen(false);
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== country || $[9] !== dict || $[10] !== isModalOpen || $[11] !== lang || $[12] !== priceInfoModalContent) {
    t6 = <Modal lang={lang} country={country} dict={dict} onModalClose={t5} open={isModalOpen} size="medium">{priceInfoModalContent}</Modal>;
    $[8] = country;
    $[9] = dict;
    $[10] = isModalOpen;
    $[11] = lang;
    $[12] = priceInfoModalContent;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t4 || $[15] !== t6) {
    t7 = <>{t4}{t6}</>;
    $[14] = t4;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  return t7;
}
export default PriceInfo;